<template>
  <page :title="$tc('publisher._name', 2)" size="is-xlarge">
    <div slot="page-header-right">
      <create-button></create-button>
    </div>

    <div class="box">
      <div class="mb-6">
        <b-input type="search" icon="magnify" :placeholder="$tc('search.publisher')" v-model="search" @input="onSearch">
        </b-input>
      </div>

      <div class="tabs is-marginless">
        <ul>
          <li :class="{ 'is-active': type === null }" @click="type = null">
            <a>{{$tc('user.all')}}</a>
          </li>

          <li :class="{ 'is-active': type === 'organization' }" @click="type = 'organization'">
            <a>{{$tc('organization')}}</a>
          </li>

          <li :class="{ 'is-active': type === 'person' }" @click="type = 'person'">
            <a>{{$tc('person')}}</a>
          </li>
        </ul>
      </div>

      <div class="card-content is-paddingless">
        <b-table class="is-middle" :loading="publishers.loading" :data="publishers.data"
          :current-page="publishers.current_page" :per-page="publishers.per_page" :total="publishers.total"
          @page-change="
            page => {
              publishers.changePage(page);
            }
          " paginated backend-pagination pagination-position="bottom">
          <template slot-scope="props">
            <b-table-column label="ID" width="100">
              <router-link :to="'/publishers/' + props.row.id">{{ props.row.id }}</router-link>
            </b-table-column>

            <b-table-column :label="$tc('publisher._name')" custom-key="name">{{ props.row.name }}</b-table-column>

            <b-table-column :label="$tc('dater.created')" centered>{{ props.row.created_at | date }}</b-table-column>

            <b-table-column custom-key="actions" centered>
              <div class="is-pulled-right">
                <router-link class="button mr-2" :to="`publishers/${props.row.id}`">
                  Detail
                </router-link>
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>No result.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>

<script>
import _ from "lodash";
import CreateButton from "./components/CreateButton";

export default {
  components: {
    CreateButton
  },

  data() {
    return {
      type: null,
      search: "",
      publishers: new window.PaginatedRemoteCollection("/admin/api/publishers"),
      authorizationsName: {
        book: "Ном",
        magazine: "Magazine",
        podcast: "Подкаст",
        printedbook: "Хэвлэмэл"
      }
    };
  },

  created() {
    this.publishers.load();
  },

  watch: {
    type() {
      if (this.ignoreTypeChangeOnce) {
        return (this.ignoreTypeChangeOnce = false);
      }

      this.publishers.filter({ type: this.type }).load();
    }
  },

  methods: {
    onSearch: _.throttle(function () {
      this.publishers.with({ search: this.search }).load();
    }, 300)
  }
};
</script>
